import { useMutation } from 'react-query';
import fetchApi from 'services/fetch';
import {
  track,
  generateServerResponseError,
  generateMessageDisplayedSegment,
  globalTrackValues,
} from 'utils/segmenTracker';
import { SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED, ACTIVATION, SERVER_RESPONSE_OK } from 'constants/segmentEvents';

const useMutationWRapper = (
  endpoint,
  callbacks = { errorCallback: null, successCallback: null, props: {} },
  config = {},
  method = 'POST'
) => {
  return useMutation(
    async (postData) => {
      console.log('19', postData);
      console.log('useMutationWrapper endpoint', endpoint);
      const { data } = await fetchApi({ method, url: endpoint, data: postData });
      return data;
    },
    {
      onSuccess: (data) => {
        if (callbacks?.props?.api) {
          track(SERVER_RESPONSE_OK, { journey: ACTIVATION, raw_response: [{ ...data }], endpoint: endpoint });
        }
        if (callbacks.successCallback) callbacks.successCallback(data);
      },
      onError: (error) => {
        if (callbacks?.props?.api) {
          track(SERVER_RESPONSE_FAILED, {
            ...generateServerResponseError(
              error,
              ACTIVATION,
              globalTrackValues.CO.page_name,
              endpoint,
              callbacks?.props?.api,
              error.message
            ),
          });
          track(MESSAGE_DISPLAYED, {
            ...generateMessageDisplayedSegment(error, ACTIVATION, callbacks?.props?.api, error.message),
          });
        }
        if (callbacks.errorCallback) callbacks.errorCallback(error);
      },
      enabled: false,
      refetchOnMount: false,
      retry: false,
      ...config,
    }
  );
};

export default useMutationWRapper;
